import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/api/client";
import { ConfirmActionDialog } from "@/components/ConfirmActionDialog";
import { formatProblem } from "@/lib/problemDetails";

interface RemoveOrganisationMembershipDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  userId: string;
  userLabel: string;
  organisationId: string;
  organisationName: string;
  onRemoved: () => void;
}

export function RemoveOrganisationMembershipDialog({
  open,
  onOpenChange,
  userId,
  userLabel,
  organisationId,
  organisationName,
  onRemoved,
}: RemoveOrganisationMembershipDialogProps) {
  const [pending, setPending] = useState(false);

  async function handleConfirm() {
    setPending(true);
    const { error } = await api.DELETE(
      "/admin/users/{userId}/organisations/{organisationId}",
      { params: { path: { userId, organisationId } } },
    );
    setPending(false);
    if (error) {
      const problem = formatProblem(error, "Failed to remove membership.");
      toast.error(problem.title, { description: problem.detail });
      return;
    }
    onRemoved();
    onOpenChange(false);
  }

  return (
    <ConfirmActionDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Remove from organisation?"
      description={
        <>
          <span className="font-medium">{userLabel}</span> will lose access to{" "}
          <span className="font-medium">{organisationName}</span>. The user account is
          kept. An organisation must always retain at least one Owner.
        </>
      }
      confirmLabel="Remove"
      pending={pending}
      onConfirm={handleConfirm}
    />
  );
}
